import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
//import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'

const divStyle = {
  backgroundColor: '#cccccc',
}

const div2Style = {
  marginTop: '-30px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'grey',
  paddingRight: '15px',
}

const linkClickStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '15px',
}

const hrStyle = {
  margin: '0px !important',
  borderTop: '0px',
}

const subtitleStyle = {
  color: '#707070',
}

class BarEmployees extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return <Fragment><nav className="navbar navbar-expand-lg navbar-light" style={div2Style}><div className="container"><div className="collapse navbar-collapse" style={subtitleStyle}>Employee</div></div></nav><nav className="navbar navbar-expand-lg navbar-light" style={divStyle}><div className="container"><div className="collapse navbar-collapse"><ul className="navbar-nav mr-auto"><li className="nav-item active"><a href="/employees" style={linkClickStyle}>Dashboard</a></li><li className="nav-item"><a href="/employee/teams" style={linkStyle}>Teams</a></li><li className="nav-item"><a href="/activity_log" style={linkStyle}>Activity log</a></li></ul></div></div></nav><hr style={hrStyle} /></Fragment>
  }
}

export default BarEmployees
